import type { Template } from "@/types";

export const PO_06_H0_V6: Template[] = [
    {
        id: "po-06-h0v6-01",
        name: "PO 01 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 76, y: 185, width: 297, height: 479, rotation: 0, imageRotation: 0 },
            { id: "2", x: 636, y: 130, width: 335, height: 590, rotation: 0, imageRotation: 0 },
            { id: "3", x: 381, y: 185, width: 145, height: 236, rotation: 0, imageRotation: 0 },
            { id: "4", x: 381, y: 429, width: 145, height: 235, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 130, width: 171, height: 291, rotation: 0, imageRotation: 0 },
            { id: "6", x: 979, y: 429, width: 171, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-02",
        name: "PO 02 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 62, y: 171, width: 149, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 430, width: 149, height: 250, rotation: 0, imageRotation: 0 },
            { id: "3", x: 219, y: 171, width: 316, height: 509, rotation: 0, imageRotation: 0 },
            { id: "4", x: 656, y: 171, width: 316, height: 509, rotation: 0, imageRotation: 0 },
            { id: "5", x: 980, y: 171, width: 149, height: 251, rotation: 0, imageRotation: 0 },
            { id: "6", x: 980, y: 430, width: 149, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-03",
        name: "PO 03 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_03.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 46, y: 130, width: 336, height: 590, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 390, y: 130, width: 160, height: 291, rotation: 0, imageRotation: 0 },
            { id: "3", x: 390, y: 429, width: 160, height: 291, rotation: 0, imageRotation: 0 },
            { id: "4", x: 675, y: 188, width: 279, height: 474, rotation: 0, imageRotation: 0 },
            { id: "5", x: 962, y: 188, width: 140, height: 233, rotation: 0, imageRotation: 0 },
            { id: "6", x: 962, y: 429, width: 140, height: 233, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-04",
        name: "PO 04 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_04.png",
        size: [1252, 894],
        style: {},
        slots: [     
            { id: "1", x: 50, y: 222, width: 244, height: 405, rotation: 0, imageRotation: 0 },
            { id: "2", x: 302, y: 222, width: 244, height: 405, rotation: 0, imageRotation: 0 },
            { id: "3", x: 644, y: 130, width: 366, height: 590, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 130, width: 123, height: 192, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 330, width: 123, height: 191, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 529, width: 123, height: 191, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-05",
        name: "PO 05 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 46, y: 218, width: 119, height: 195, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 421, width: 119, height: 194, rotation: 0, imageRotation: 0 },
            { id: "3", x: 172, y: 218, width: 237, height: 396, rotation: 0, imageRotation: 0 },
            { id: "4", x: 416, y: 218, width: 119, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 416, y: 421, width: 119, height: 194, rotation: 0, imageRotation: 0 },
            { id: "6", x: 595, y: 0, width: 595, height: 850, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h0v6-06",
        name: "PO 06 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_06.png",
        size: [1190, 850],
        style: {},
        slots: [      
            { id: "1", x: 48, y: 127, width: 120, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 48, y: 322, width: 120, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 517, width: 120, height: 187, rotation: 0, imageRotation: 0 },
            { id: "4", x: 176, y: 127, width: 358, height: 577, rotation: 0, imageRotation: 0 },
            { id: "5", x: 630, y: 218, width: 240, height: 396, rotation: 0, imageRotation: 0 },
            { id: "6", x: 878, y: 218, width: 240, height: 396, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-07",
        name: "PO 07 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 595, height: 850, rotation: 0, imageRotation: 0 },
            { id: "2", x: 640, y: 222, width: 250, height: 405, rotation: 0, imageRotation: 0 },
            { id: "3", x: 898, y: 222, width: 121, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 898, y: 429, width: 121, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1027, y: 222, width: 120, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1027, y: 429, width: 120, height: 198, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-08",
        name: "PO 08 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_08.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 0, y: 135, width: 408, height: 579, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 416, y: 135, width: 175, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 416, y: 429, width: 175, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 135, width: 175, height: 286, rotation: 0, imageRotation: 0 },
            { id: "5", x: 599, y: 429, width: 175, height: 285, rotation: 0, imageRotation: 0 },
            { id: "6", x: 783, y: 135, width: 408, height: 580, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-06-h0v6-09",
        name: "PO 09 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 271, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 200, y: 271, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 400, y: 271, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 600, y: 271, width: 192, height: 309, rotation: 0, imageRotation: 0 },
            { id: "5", x: 800, y: 271, width: 191, height: 309, rotation: 0, imageRotation: 0 },
            { id: "6", x: 999, y: 271, width: 191, height: 309, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h0v6-10",
        name: "PO 10 - H0V6",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h0_v6_10.png",
        size: [1252, 894],
        style: {},
        slots: [
            { id: "1", x: 53, y: 282, width: 174, height: 286, rotation: 0, imageRotation: 0 },
            { id: "2", x: 235, y: 282, width: 174, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 282, width: 174, height: 286, rotation: 0, imageRotation: 0 },
            { id: "4", x: 599, y: 282, width: 174, height: 286, rotation: 0, imageRotation: 0 },
            { id: "5", x: 781, y: 282, width: 174, height: 286, rotation: 0, imageRotation: 0 },
            { id: "6", x: 963, y: 282, width: 174, height: 286, rotation: 0, imageRotation: 0 }
        ],
    }
];